import { AIGeneratedSong } from '../../../entities';
import { handleErrors } from '../../../helpers';
import { BaseSongResponse } from '../../../responses/responseTypes';
import { Client } from '../../client';
import { AIRepository, GetTrackPayload } from '../../repositories/aiRepository';

export default class AIRepositoryImpl implements AIRepository {
  protectedClient: Client;

  externalClient: Client;

  constructor(protectedClient: Client, externalClient: Client) {
    this.protectedClient = protectedClient;
    this.externalClient = externalClient;
  }

  async getAIGeneratedSong(payload: GetTrackPayload) {
    const { protectedClient } = this;
    return protectedClient
      .get<BaseSongResponse>(`/ai/vega/songs/${payload.id}`)
      .then((response) => new AIGeneratedSong(response.data))
      .catch((err) => {
        const error = handleErrors(err);
        throw error;
      });
  }
}
